import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Hero = () => {
  const [sliders, setSliders] = useState([]);
  const [settings, setSettings] = useState({
    hero_text: 'Raih Prestasi Tertinggi Bersama Bimbel Kedinasan Stema Kupang!'
  });
  
  const sliderRef = useRef(null);

  // Fetch sliders
  useEffect(() => {
    fetch('https://app.bimbelstemakupang.com/api/sliders')
      .then((response) => response.json())
      .then((data) => setSliders(data))
      .catch((error) => console.error('Error fetching slider data:', error));
  }, []);

  // Fetch settings untuk hero text
  useEffect(() => {
    fetch('https://app.bimbelstemakupang.com/api/settings')
      .then((response) => response.json())
      .then((data) => {
        if (data && data.hero_text) {
          setSettings({
            hero_text: data.hero_text
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching settings:', error);
      });
  }, []);

  const settings_slider = {
    dots: true,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    cssEase: 'cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    dotsClass: 'slick-dots custom-dots',
  };

  const createMarkup = (htmlString) => {
    return { __html: htmlString };
  };

  return (
    <>
      {/* Custom CSS untuk animasi dan styling */}
      <style jsx>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes slideInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes pulse {
          0%, 100% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
        }

        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .hero-content {
          animation: slideInLeft 1s ease-out;
        }

        .hero-image {
          animation: slideInRight 1s ease-out 0.3s both;
        }

        .hero-btns .btn {
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
        }

        .hero-btns .btn::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
          transition: left 0.5s;
        }

        .hero-btns .btn:hover::before {
          left: 100%;
        }

        .hero-btns .btn:hover {
          transform: translateY(-3px);
          box-shadow: 0 10px 25px rgba(0,0,0,0.2);
        }

        .stat-item {
          animation: fadeInUp 1s ease-out 0.8s both;
          transition: transform 0.3s ease;
        }

        .stat-item:hover {
          transform: translateY(-5px);
        }

        .stat-item h3 {
          background: linear-gradient(45deg, #ffc107, #ff6b35);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          animation: pulse 2s infinite;
        }

        .custom-dots {
          bottom: -50px !important;
        }

        .custom-dots li button:before {
          font-size: 14px !important;
          color: rgba(255,255,255,0.5) !important;
        }

        .custom-dots li.slick-active button:before {
          color: #ffc107 !important;
        }

        .slider-image {
          position: relative;
          overflow: hidden;
        }

        .slider-image::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(45deg, rgba(220,53,69,0.1), rgba(255,193,7,0.1));
          z-index: 1;
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .slider-image:hover::before {
          opacity: 1;
        }

        .floating-elements {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
        }

        .floating-circle {
          position: absolute;
          border-radius: 50%;
          background: rgba(255,255,255,0.1);
          animation: float 6s ease-in-out infinite;
        }

        .floating-circle:nth-child(1) {
          width: 80px;
          height: 80px;
          top: 20%;
          left: 10%;
          animation-delay: 0s;
        }

        .floating-circle:nth-child(2) {
          width: 60px;
          height: 60px;
          top: 60%;
          right: 15%;
          animation-delay: 2s;
        }

        .floating-circle:nth-child(3) {
          width: 40px;
          height: 40px;
          top: 40%;
          left: 80%;
          animation-delay: 4s;
        }

        .hero {
          background: linear-gradient(135deg, #3e6ff4 0%, #357eef 100%);
          position: relative;
          overflow: hidden;
        }

        .hero::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="1"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
          opacity: 0.3;
        }

        @media (max-width: 768px) {
          .hero-content {
            text-align: center;
            margin-bottom: 2rem;
          }
          
          .hero-stats {
            justify-content: center !important;
          }
          
          .stat-item {
            margin: 0 1rem !important;
          }
        }
      `}</style>

      <section id="hero" className="hero section dark-background">
        {/* Floating Background Elements */}
        <div className="floating-elements">
          <div className="floating-circle"></div>
          <div className="floating-circle"></div>
          <div className="floating-circle"></div>
        </div>

        <div className="container">
          <div className="row align-items-center min-vh-100">
            <div className="col-lg-6">
              <div className="hero-content">
                {/* Hero text dengan gradient dan animasi */}
                <div 
                  dangerouslySetInnerHTML={createMarkup(settings.hero_text)}
                  style={{
                    fontSize: 'clamp(2rem, 4vw, 3.5rem)',
                    fontWeight: '700',
                    marginBottom: '1.5rem',
                    background: 'linear-gradient(45deg, #ffffff, #ffc107)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    lineHeight: '1.2',
                    textShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                />
                
                {/* Subtitle */}
                <p style={{
                  fontSize: '1.2rem',
                  color: 'rgba(255,255,255,0.9)',
                  marginBottom: '2.5rem',
                  lineHeight: '1.6',
                  fontWeight: '300'
                }}>
                  Belajar jadi lebih mudah, menyenangkan, dan terarah. Siap menghadapi 
                  ujian dan masa depan bersama mentor terbaik!
                </p>
                
                <div className="hero-btns d-flex flex-wrap gap-3" style={{ marginBottom: '3rem' }}>
                  <a 
                    href="#consultation" 
                    className="btn btn-primary"
                    style={{
                      background: 'linear-gradient(45deg, #dc3545, #fd7e14)',
                      border: 'none',
                      padding: '15px 35px',
                      fontSize: '1.1rem',
                      borderRadius: '50px',
                      fontWeight: '600',
                      textDecoration: 'none',
                      color: 'white',
                      boxShadow: '0 8px 25px rgba(220,53,69,0.3)'
                    }}
                  >
                    🚀 Daftar Sekarang
                  </a>
                  <a 
                    href="#services" 
                    className="btn btn-outline-light"
                    style={{
                      padding: '15px 35px',
                      fontSize: '1.1rem',
                      borderRadius: '50px',
                      borderColor: 'rgba(255,255,255,0.8)',
                      color: 'white',
                      borderWidth: '2px',
                      fontWeight: '600',
                      textDecoration: 'none',
                      backgroundColor: 'rgba(255,255,255,0.1)',
                      backdropFilter: 'blur(10px)'
                    }}
                  >
                    📋 Lihat Program
                  </a>
                </div>
                
                {/* Enhanced Statistics */}
                <div className="hero-stats d-flex flex-wrap mt-4">
                  <div className="stat-item me-5 mb-3" style={{ 
                    color: 'white',
                    padding: '20px',
                    borderRadius: '15px',
                    background: 'rgba(255,255,255,0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}>
                    <h3 style={{ 
                      fontSize: '2.5rem',
                      marginBottom: '0.5rem',
                      fontWeight: '800'
                    }}>15+</h3>
                    <p style={{ 
                      color: 'rgba(255,255,255,0.8)', 
                      margin: 0,
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>Tahun Pengalaman</p>
                  </div>
                  <div className="stat-item me-5 mb-3" style={{ 
                    color: 'white',
                    padding: '20px',
                    borderRadius: '15px',
                    background: 'rgba(255,255,255,0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}>
                    <h3 style={{ 
                      fontSize: '2.5rem',
                      marginBottom: '0.5rem',
                      fontWeight: '800'
                    }}>500+</h3>
                    <p style={{ 
                      color: 'rgba(255,255,255,0.8)', 
                      margin: 0,
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>Siswa Berhasil</p>
                  </div>
                  <div className="stat-item mb-3" style={{ 
                    color: 'white',
                    padding: '20px',
                    borderRadius: '15px',
                    background: 'rgba(255,255,255,0.1)',
                    backdropFilter: 'blur(10px)',
                    border: '1px solid rgba(255,255,255,0.2)'
                  }}>
                    <h3 style={{ 
                      fontSize: '2.5rem',
                      marginBottom: '0.5rem',
                      fontWeight: '800'
                    }}>98%</h3>
                    <p style={{ 
                      color: 'rgba(255,255,255,0.8)', 
                      margin: 0,
                      fontSize: '0.9rem',
                      fontWeight: '500'
                    }}>Tingkat Kelulusan</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="hero-image" style={{ position: 'relative' }}>
                {sliders.length > 0 ? (
                  <div style={{ 
                    borderRadius: '25px', 
                    overflow: 'hidden', 
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
                    border: '3px solid rgba(255,255,255,0.2)',
                    background: 'rgba(255,255,255,0.1)',
                    backdropFilter: 'blur(10px)'
                  }}>
                    <Slider ref={sliderRef} {...settings_slider}>
                      {sliders.map((slider) => (
                        <div key={slider.id} className="slider-image">
                          <img 
                            src={`https://app.bimbelstemakupang.com/storage/${slider.image}`} 
                            alt={slider.title} 
                            className="img-fluid"
                            style={{
                              width: '100%',
                              height: '90%',
                              objectFit: 'cover',
                              transition: 'transform 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.transform = 'scale(1)';
                            }}
                          />
                        </div>
                      ))}
                    </Slider>
                  </div>
                ) : (
                  <div 
                    className="d-flex align-items-center justify-content-center"
                    style={{
                      height: '500px',
                      borderRadius: '25px',
                      background: 'linear-gradient(45deg, rgba(255,255,255,0.1), rgba(255,255,255,0.05))',
                      backdropFilter: 'blur(10px)',
                      border: '2px solid rgba(255,255,255,0.2)',
                      color: 'rgba(255,255,255,0.8)'
                    }}
                  >
                    <div className="text-center">
                      <div className="spinner-border text-warning mb-3" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p style={{ fontSize: '1.1rem', fontWeight: '500' }}>Memuat galeri...</p>
                    </div>
                  </div>
                )}

                {/* Enhanced Slider Controls */}
                {sliders.length > 0 && (
                  <div className="slider-controls" style={{
                    position: 'absolute',
                    bottom: '30px',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    display: 'flex',
                    gap: '15px'
                  }}>
                    <button 
                      className="slider-btn" 
                      onClick={() => sliderRef.current?.slickPrev()}
                      style={{
                        background: 'rgba(255,255,255,0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '55px',
                        height: '55px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
                        transition: 'all 0.3s ease',
                        backdropFilter: 'blur(10px)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255,193,7,0.9)';
                        e.target.style.transform = 'scale(1.1)';
                        e.target.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'scale(1)';
                        e.target.style.color = 'initial';
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="15,18 9,12 15,6"></polyline>
                      </svg>
                    </button>
                    <button 
                      className="slider-btn" 
                      onClick={() => sliderRef.current?.slickNext()}
                      style={{
                        background: 'rgba(255,255,255,0.9)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '55px',
                        height: '55px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        boxShadow: '0 8px 25px rgba(0,0,0,0.2)',
                        transition: 'all 0.3s ease',
                        backdropFilter: 'blur(10px)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.background = 'rgba(255,193,7,0.9)';
                        e.target.style.transform = 'scale(1.1)';
                        e.target.style.color = 'white';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.background = 'rgba(255,255,255,0.9)';
                        e.target.style.transform = 'scale(1)';
                        e.target.style.color = 'initial';
                      }}
                    >
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="9,18 15,12 9,6"></polyline>
                      </svg>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Hero;